(() => {
  'use strict';
  const copy = window.tdtPurchaseCopy;
  if (!copy || window.tdtPurchase) return;
  async function request(input, options = {}, format = 'json') {
    const controller = new AbortController();
    let timer;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => {
        reject(new Error(copy.timeout));
        controller.abort();
      }, 15000);
    });
    const work = (async () => {
      const response = await fetch(input, { ...options, signal: controller.signal });
      const data = await response[format]();
      if (!response.ok) throw new Error(format === 'json' && (data?.description || data?.message) || copy.failed);
      return data;
    })();
    try { return await Promise.race([work, timeout]); }
    finally { clearTimeout(timer); }
  }
  function checkouts(cart) {
    try {
      const value = JSON.parse(cart?.attributes?._vivenuCheckouts || 'null');
      if (Array.isArray(value)) return value;
    } catch (_) {}
    return Array.isArray(window.vivenu?.checkouts) ? window.vivenu.checkouts : [];
  }
  window.tdtPurchase = { request, checkouts, copy };
})();
